import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function CoolingTowerIcon(props) {
	return (
		<IconBase type="cooling-tower" {...props}>
			<path d="M4.5 2H10V2.5C9.74687 2.5 9.54167 2.94772 9.54167 3.5C9.54167 4.05228 9.74687 4.5 10 4.5H4.5C4.75313 4.5 4.95833 4.05228 4.95833 3.5C4.95833 2.94772 4.75313 2.5 4.5 2.5V2Z" />
			<path d="M14 2H19.5V2.5C19.2469 2.5 19.0417 2.94772 19.0417 3.5C19.0417 4.05228 19.2469 4.5 19.5 4.5H14C14.2531 4.5 14.4583 4.05228 14.4583 3.5C14.4583 2.94772 14.2531 2.5 14 2.5V2Z" />
			<path d="M3 5H11.5V20H3V5ZM3.89474 8V8.5H6.57895V8H3.89474ZM6.57895 6.5H3.89474V7H6.57895V6.5ZM3.89474 9.5V10H6.57895V9.5H3.89474ZM10.6053 8H7.92105V8.5H10.6053V8ZM7.92105 6.5V7H10.6053V6.5H7.92105ZM10.6053 9.5H7.92105V10H10.6053V9.5Z" />
			<path d="M12.5 5H21V20H12.5V5ZM13.3947 8V8.5H16.0789V8H13.3947ZM16.0789 6.5H13.3947V7H16.0789V6.5ZM13.3947 9.5V10H16.0789V9.5H13.3947ZM20.1053 8H17.4211V8.5H20.1053V8ZM17.4211 6.5V7H20.1053V6.5H17.4211ZM20.1053 9.5H17.4211V10H20.1053V9.5Z" />
			<path d="M6 21.5V20.5H3V21.5H6Z" />
			<path d="M10.5 20.5H13.5V21.5H10.5V20.5Z" />
			<path d="M21 21.5V20.5H18V21.5H21Z" />
		</IconBase>
	);
}
CoolingTowerIcon.propTypes = iconPropTypes;
